

import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import Button from '../../../components/base/Button';

export default function IVTherapyPage() {
  const handleConsultationClick = () => {
    window.REACT_APP_NAVIGATE('/consultation');
  };

  const ivTreatments = [
    {
      name: 'Rapid Hydration Drip',
      description: 'Provides immediate rehydration by delivering fluids and electrolytes directly into the bloodstream',
      ingredients: ['Saline solution', 'Electrolytes', 'Essential minerals'],
      benefits: ['Immediate rehydration', 'Relieves headaches', 'Reduces fatigue', 'Eliminates dizziness'],
      duration: '30-45 minutes',
      priceRange: '$20-$80'
    },
    {
      name: 'Immune Support Drip',
      description: 'Infuses high doses of vitamin C, zinc, and other antioxidants to strengthen the immune system',
      ingredients: ['High-dose Vitamin C', 'Zinc', 'Antioxidants', 'B-Vitamins'],
      benefits: ['Strengthens immune system', 'Fights infections', 'Antioxidant protection', 'Enhanced resistance'],
      duration: '60-90 minutes',
      priceRange: '$80-$150'
    },
    {
      name: 'Energy Boost Drip',
      description: 'Contains B vitamins and other nutrients to combat fatigue and boost energy levels',
      ingredients: ['B-Complex vitamins', 'B12', 'L-Carnitine', 'Amino acids'],
      benefits: ['Combats fatigue', 'Boosts energy levels', 'Improves focus', 'Enhanced daily performance'],
      duration: '45-60 minutes',
      priceRange: '$60-$120'
    },
    {
      name: 'Hangover Relief Drip',
      description: 'Replenishes lost fluids and electrolytes, includes anti-nausea medication',
      ingredients: ['Saline solution', 'Electrolytes', 'Anti-nausea medication', 'B-Vitamins'],
      benefits: ['Alleviates hangover symptoms', 'Reduces headaches', 'Eliminates nausea', 'Rapid recovery'],
      duration: '30-45 minutes',
      priceRange: '$40-$100'
    },
    {
      name: 'Athletic Performance Drip',
      description: 'Helps athletes rehydrate and replenish essential nutrients before or after intense workouts',
      ingredients: ['Amino acids', 'Electrolytes', 'B-Vitamins', 'Magnesium'],
      benefits: ['Improves performance', 'Aids recovery', 'Muscle support', 'Enhanced endurance'],
      duration: '45-75 minutes',
      priceRange: '$80-$160'
    },
    {
      name: 'Skin Health Drip',
      description: 'Delivers nutrients that improve skin hydration, elasticity, and radiance',
      ingredients: ['Vitamin C', 'Glutathione', 'Biotin', 'Collagen boosters'],
      benefits: ['Improved skin hydration', 'Enhanced elasticity', 'Radiant complexion', 'Antioxidant protection'],
      duration: '60-90 minutes',
      priceRange: '$100-$180'
    },
    {
      name: 'Weight Management Drip',
      description: 'Includes MIC B12 blend and other fat-metabolizing nutrients to support weight loss',
      ingredients: ['MIC B12 blend', 'Methionine', 'Inositol', 'Choline', 'L-Carnitine'],
      benefits: ['Supports weight loss', 'Boosts metabolism', 'Fat burning support', 'Energy enhancement'],
      duration: '45-60 minutes',
      priceRange: '$70-$140'
    },
    {
      name: 'Migraine Relief Drip',
      description: 'Provides relief from migraines by delivering pain-reducing nutrients and replenishing fluids',
      ingredients: ['Magnesium', 'B-Vitamins', 'Saline solution', 'Pain-relief nutrients'],
      benefits: ['Migraine relief', 'Reduces pain', 'Fluid replenishment', 'Symptom alleviation'],
      duration: '45-75 minutes',
      priceRange: '$60-$130'
    },
    {
      name: 'NAD+ Infusion',
      description: 'Advanced anti-aging and cellular repair therapy for optimal brain and body function',
      ingredients: ['NAD+', 'Supporting vitamins', 'Cellular repair nutrients'],
      benefits: ['Cellular repair', 'Anti-aging effects', 'Enhanced brain function', 'Energy optimization'],
      duration: '90-180 minutes',
      priceRange: '$150-$280'
    },
    {
      name: 'Glutathione Infusion',
      description: 'Master antioxidant therapy for detoxification and cellular protection',
      ingredients: ['Glutathione', 'Vitamin C', 'Supporting antioxidants'],
      benefits: ['Powerful detoxification', 'Cellular protection', 'Skin brightening', 'Immune support'],
      duration: '30-60 minutes',
      priceRange: '$80-$150'
    },
    {
      name: 'Detox Drip',
      description: 'Specifically formulated to help the body flush out toxins and promote optimal liver function',
      ingredients: ['Glutathione', 'Vitamin C', 'B-Complex', 'Liver support nutrients'],
      benefits: ['Toxin elimination', 'Liver function support', 'Cellular cleansing', 'Enhanced wellness'],
      duration: '60-90 minutes',
      priceRange: '$90-$170'
    },
    {
      name: 'Jet Lag Relief Drip',
      description: 'Helps travelers combat jet lag by rapidly replenishing fluids and nutrients',
      ingredients: ['Saline solution', 'B-Vitamins', 'Electrolytes', 'Energy nutrients'],
      benefits: ['Combats jet lag', 'Rapid rehydration', 'Alleviates travel fatigue', 'Restores energy'],
      duration: '45-60 minutes',
      priceRange: '$50-$110'
    }
  ];

  const benefits = [
    {
      icon: 'ri-shield-check-line',
      title: 'Immune Support',
      description: 'Strengthen your immune system with high-dose vitamins and antioxidants'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Detoxification',
      description: 'Eliminate toxins and support your body\'s natural detox processes'
    },
    {
      icon: 'ri-time-line',
      title: 'Anti-Aging',
      description: 'Combat cellular aging with powerful antioxidants and nutrients'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Energy Boost',
      description: 'Experience immediate and sustained energy enhancement'
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-[#8A4F8A] to-[#C8A2C8] text-white overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://public.readdy.ai/ai/img_res/a741e16bc6a300d581168846468f9b2a.jpg)'
          }}
        ></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">
              Revitalize with <span className="text-[#F0F0F0]">IV Therapy</span>
            </h1>
            <p className="text-xl mb-8 text-[#F0F0F0]">
              Direct nutrient delivery for maximum absorption and immediate results. 
              Boost your energy, immunity, and overall wellness with our customized IV treatments.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button size="lg" className="bg-white text-[#8A4F8A] hover:bg-[#F0F0F0]" onClick={handleConsultationClick}>
                <i className="ri-calendar-line mr-2"></i>
                Book IV Session
              </Button>
              <Button size="lg" variant="secondary" className="border-white text-white hover:bg-white hover:text-[#8A4F8A]" onClick={() => window.open('tel:202-269-6600', '_self')}>
                <i className="ri-phone-line mr-2"></i>
                Call 202-269-6600
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-black mb-4">
              Why Choose <span className="text-[#8A4F8A]">IV Therapy</span>
            </h2>
            <p className="text-xl text-[#B0B0B0] max-w-3xl mx-auto">
              Experience the immediate benefits of direct nutrient delivery
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-[#8A4F8A] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${benefit.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-black mb-3">{benefit.title}</h3>
                <p className="text-[#B0B0B0]">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Overview Section */}
      <section className="py-16 bg-gradient-to-b from-[#F0F0F0] to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-black mb-4">
            Affordable <span className="text-[#8A4F8A]">IV Therapy</span>
          </h2>
          <p className="text-xl text-[#B0B0B0] mb-8">
            Starting from just $20, with treatments up to $280 for advanced therapies
          </p>
          
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-[#8A4F8A] mb-2">$20-$80</div>
                <div className="text-black font-semibold">Basic Treatments</div>
                <div className="text-[#B0B0B0] text-sm">Hydration, Hangover Relief</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-[#8A4F8A] mb-2">$80-$180</div>
                <div className="text-black font-semibold">Premium Treatments</div>
                <div className="text-[#B0B0B0] text-sm">Immune Support, Skin Health</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-[#8A4F8A] mb-2">$150-$280</div>
                <div className="text-black font-semibold">Advanced Therapies</div>
                <div className="text-[#B0B0B0] text-sm">NAD+, Specialized Infusions</div>
              </div>
            </div>
            
            <div className="mt-8 p-4 bg-[#C8A2C8]/20 rounded-lg">
              <p className="text-black font-semibold mb-2">
                <i className="ri-gift-line text-[#8A4F8A] mr-2"></i>
                Package Discounts Available
              </p>
              <p className="text-[#B0B0B0] text-sm">
                Save more with our treatment packages and bundle deals
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* IV Treatments Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-black mb-4">
              Our <span className="text-[#8A4F8A]">IV Treatments</span>
            </h2>
            <p className="text-xl text-[#B0B0B0] max-w-3xl mx-auto">
              Customized nutrient infusions for your specific health goals
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {ivTreatments.map((treatment, index) => (
              <div key={index} className="bg-gradient-to-b from-[#F0F0F0] to-white rounded-xl shadow-lg p-6">
                <div className="flex justify-between items-start mb-4">
                  <h3 className="text-lg font-bold text-black">{treatment.name}</h3>
                  <div className="text-right">
                    <div className="text-sm text-[#8A4F8A] bg-[#C8A2C8]/20 px-2 py-1 rounded-full mb-1">
                      {treatment.duration}
                    </div>
                    <div className="text-sm font-semibold text-black">
                      {treatment.priceRange}
                    </div>
                  </div>
                </div>
                <p className="text-[#B0B0B0] mb-4 text-sm">{treatment.description}</p>
                
                <div className="mb-4">
                  <h4 className="font-semibold text-black mb-2 text-sm">Key Ingredients:</h4>
                  <div className="flex flex-wrap gap-1">
                    {treatment.ingredients.map((ingredient, idx) => (
                      <span key={idx} className="text-xs bg-[#F0F0F0] text-black px-2 py-1 rounded-full">
                        {ingredient}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="mb-4">
                  <h4 className="font-semibold text-black mb-2 text-sm">Benefits:</h4>
                  <ul className="space-y-1">
                    {treatment.benefits.slice(0, 3).map((benefit, idx) => (
                      <li key={idx} className="flex items-center text-black text-xs">
                        <i className="ri-check-line text-[#8A4F8A] mr-2"></i>
                        {benefit}
                      </li>
                    ))}
                  </ul>
                </div>

                <Button className="w-full" size="sm" onClick={handleConsultationClick}>
                  Book This Treatment
                </Button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-16 bg-gradient-to-b from-[#F0F0F0] to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-black mb-4">
              What to <span className="text-[#8A4F8A]">Expect</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              { step: '1', title: 'Consultation', description: 'Discuss your health goals and select the right IV treatment' },
              { step: '2', title: 'Preparation', description: 'Relax in our comfortable treatment room while we prepare your IV' },
              { step: '3', title: 'Treatment', description: 'Receive your customized nutrient infusion in a relaxing environment' },
              { step: '4', title: 'Recovery', description: 'Feel the immediate benefits and plan your next session' }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-12 h-12 bg-[#8A4F8A] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold">{item.step}</span>
                </div>
                <h3 className="text-lg font-bold text-black mb-2">{item.title}</h3>
                <p className="text-[#B0B0B0] text-sm">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-[#8A4F8A] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-4">Ready to Feel Revitalized?</h2>
          <p className="text-xl mb-8 text-[#F0F0F0]">
            Experience the immediate benefits of IV therapy today
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" className="bg-white text-[#8A4F8A] hover:bg-[#F0F0F0]" onClick={handleConsultationClick}>
              <i className="ri-calendar-line mr-2"></i>
              Book IV Session
            </Button>
            <Button size="lg" variant="secondary" className="border-white text-white hover:bg-white hover:text-[#8A4F8A]" onClick={() => window.open('tel:202-269-6600', '_self')}>
              <i className="ri-phone-line mr-2"></i>
              Call 202-269-6600
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
